import React from "react"

import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import PageSection from "../../pageSection/pageSection.js"
import H2 from "../../h2/h2.js"
import { QRCodeModalProvider } from "../../qrcodeModal/qrcodeModalContext.js";
import QRCodeModalButton from "../../qrcodeModal/qrcodeModalButton.js";

import styles from "./noFees.module.scss"

const NoFeesSection = () => {
  const data = useStaticQuery(graphql`
    query {
      scooterCardPhone: file(relativePath: { eq: "home/all-the-benefits.png" }) {
        childImageSharp {
          gatsbyImageData (
            width: 830
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
    }
  `)

  return (
    <PageSection
      backgroundColor="#ffffff"
      centerVertical
      collapseAt="large"
      LeftComponent={() =>
        <div className={styles.scooterKidContainer}>
          <GatsbyImage
            image={getImage(data.scooterCardPhone)}
            alt="Illustrated image of a girl on a scooter smiling, next to a phone showing the Till app as well as a Till debit card"
            width={750}
          />
        </div>
      }
    >
      <div className={styles.scooterCopyContainer}>
        <H2 className={styles.h2} slideUp>
          All the benefits of family money management. None of the fees.
        </H2>
        <QRCodeModalProvider>
          <div className={styles.textToDownloadContainer}>
            <div className={styles.textToDownloadButton}>
              <QRCodeModalButton eventLabel="Home Page - No Fees" />
            </div>
          </div>
        </QRCodeModalProvider>
      </div>
    </PageSection>
  )
}

export { NoFeesSection }
